<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="form-group"
  [ngClass]="{ half: ishalf, mfd: isMfd, 'mb-0': isMfd, disabled: disabled }">
  @if (label) {
    <label for="label" [xdaTranslate]="label"></label>
  }
  <textarea
    #textarea
    textarea="ngModel"
    ngModel
    keep-placeholder
    [id]="id"
    [attr.name]="name"
    [cols]="cols"
    [rows]="rows"
    [maxlength]="maxlength"
    [disabled]="disabled"
    [readonly]="readonly"
    [required]="required"
    [wrap]="wrap"
    [placeholder]="placeholder"
    (input)="onChange($any($event.target).value)"
    (keypress)="onKeyPress($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    [ngClass]="{
      'is-invalid': isErrorState() || onSubmitError,
      'col-sm-8': ishalf,
      'mfd-input': isMfd,
    }"
    class="form-control">
  </textarea>

  @if ((isErrorState() || onSubmitError) && hasAnyError()) {
    <div
      class="invalid-feedback"
      [ngClass]="{ 'offset-md-4 col-sm-8': ishalf }">
      @if (ngControl.control?.errors?.['required']) {
        <div [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></div>
      }
      @if (ngControl.control?.errors?.['maxlength'] && !maxlengtherror) {
        <div>
          <span xdaTranslate>SDE_MAX_LENGTH1</span>&nbsp;<span
            [xdaTranslate]="maxlength.toString()"></span>
        </div>
      }
      @if (ngControl.control?.errors?.['maxlength'] && maxlengtherror) {
        <div>
          <span>{{ maxlengtherror }}</span>
        </div>
      }
      @if (ngControl.control?.errors?.['customerror']) {
        <div [xdaTranslate]="error"></div>
      }
    </div>
  }
</div>
